<template>
  <div class="government-header-wrapper">
    <!-- Top Utility Bar -->
    <div class="top-utility-bar">
      <div class="container-fluid px-4">
        <div class="d-flex justify-content-between align-items-center">
          <div class="gov-title">
            <span class="marathi-text">महाराष्ट्र शासन</span>
            <span class="separator">|</span>
            <span class="english-text">GOVERNMENT OF MAHARASHTRA</span>
          </div>

        </div>
      </div>
    </div>

    <!-- Main Header -->
    <div class="main-header">
      <div class="container-fluid px-4">
        <div class="header-content">
          <!-- Left Section: Government Emblem -->
          <div class="emblem-section">
            <img
              src="@/assets/images/emblem.svg"
              alt="Government of India Emblem"
              class="gov-emblem"
            />

          </div>

          <!-- Center Section: Department Information -->
          <div class="department-info">
            <h1 class="dept-name-english">महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी</h1>
            <h2 class="dept-name-marathi">संत श्री. संताजी महाराज आर्थिक विकास महामंडळ</h2>
            <p class="dept-name-marathi-sub">(महाराष्ट्र शासनाचा उपक्रम)</p>
          </div>

          <!-- Right Section: State Emblem and Digital India Logo -->
          <div class="logo-section">
            <img
              src="@/assets/images/202508051536223135.png"
              alt="Maharashtra Government"
              class="state-emblem"
            />
            <img
              src="@/assets/images/logo.png"
              alt="Digital India"
              class="digital-india-logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GovernmentHeader',
  data() {
    return {};
  }
};
</script>

<style scoped>
/* Top Utility Bar Styles */
.top-utility-bar {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 6px 0;
  font-size: 12px;
}

.gov-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.marathi-text {
  font-family: 'Laila', serif;
  font-weight: 600;
  color: #495057;
  font-size: 13px;
}

.separator {
  color: #6c757d;
  font-weight: 300;
}

.english-text {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-size: 12px;
}

.utility-icons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.icon-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  border-radius: 3px;
  color: #495057;
  text-decoration: none;
  transition: all 0.2s ease;
  font-size: 13px;
  background-color: #fff;
}

.icon-btn:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: #212529;
  text-decoration: none;
}

.font-size-btn {
  font-weight: bold;
  font-size: 11px;
}

.font-size-btn sup {
  font-size: 9px;
}

/* Main Header Styles */
.main-header {
  background: #ffffff;
  padding: 15px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border-bottom: 3px solid #ff6600;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}

.emblem-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 90px;
}

.gov-emblem {
  width: 70px;
  height: auto;
  margin-bottom: 5px;
}

.emblem-text {
  font-family: 'Laila', serif;
  font-size: 10px;
  font-weight: 500;
  color: #495057;
  margin: 0;
  text-align: center;
}

.department-info {
  flex: 1;
  text-align: left;
}

.dept-name-english {
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.dept-name-marathi {
  font-family: 'Laila', serif;
  font-size: 20px;
  font-weight: 700;
  color: #1a252f;
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.dept-name-marathi-sub {
  font-family: 'Laila', serif;
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  margin: 0;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 20px;
  min-width: 200px;
  justify-content: flex-end;
}

.state-emblem {
  height: 70px;
  width: auto;
}

.digital-india-logo {
  height: 55px;
  width: auto;
}

/* Responsive Design */
@media (max-width: 991px) {
  .header-content {
    gap: 20px;
  }

  .dept-name-english {
    font-size: 16px;
  }

  .dept-name-marathi {
    font-size: 18px;
  }

  .dept-name-marathi-sub {
    font-size: 13px;
  }

  .gov-emblem {
    width: 60px;
  }

  .state-emblem {
    height: 60px;
  }

  .digital-india-logo {
    height: 45px;
  }

  .logo-section {
    gap: 15px;
  }
}

@media (max-width: 767px) {
  .top-utility-bar {
    font-size: 11px;
  }

  .utility-icons {
    gap: 5px;
  }

  .icon-btn {
    width: 26px;
    height: 26px;
    font-size: 11px;
  }

  .header-content {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .emblem-section {
    min-width: 60px;
  }

  .gov-emblem {
    width: 50px;
  }

  .emblem-text {
    font-size: 9px;
  }

  .department-info {
    text-align: center;
    order: 3;
    flex-basis: 100%;
  }

  .dept-name-english {
    font-size: 14px;
  }

  .dept-name-marathi {
    font-size: 16px;
  }

  .dept-name-marathi-sub {
    font-size: 12px;
  }

  .logo-section {
    min-width: auto;
  }

  .state-emblem {
    height: 50px;
  }

  .digital-india-logo {
    height: 40px;
  }
}

@media (max-width: 575px) {
  .gov-title .english-text {
    display: none;
  }

  .gov-title .separator {
    display: none;
  }

  .marathi-text {
    font-size: 12px;
  }

  .dept-name-english {
    font-size: 12px;
  }

  .dept-name-marathi {
    font-size: 14px;
  }

  .logo-section {
    gap: 10px;
  }

  .state-emblem {
    height: 45px;
  }

  .digital-india-logo {
    height: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GovernmentHeader.vue